import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { Observer } from 'gsap/Observer'

gsap.registerPlugin(Observer)

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    this.state = false
    this.btn = document.querySelector('.c-header__burger')
    this.btn.setAttribute('aria-expanded', false)
    this.btn.addEventListener('click', () => {
      this.toggleMenu()
    })

    this.setTimeline()

    // Highway skips same-URL navigations, so page:change never fires —
    // close the menu when any link is clicked (incl. current page).
    this.el.addEventListener('click', (e) => {
      if (e.target.closest('a')) this.closeMenu()
    })

    document.addEventListener('page:change', () => {
      this.closeMenu()
    })

    this.scrollPosition = 0
    this.scrollWidth = 0
  }

  setTimeline() {
    this.tl = gsap
      .timeline({
        yoyo: true,
        paused: true,
      })
      .set('.c-header__logo', {
        autoAlpha: 0,
      })
      .to(
        '.c-header__mobile',
        {
          xPercent: 100,
          duration: 0.25,
        },
        '<',
      )
      .add(this.burgerTimeline(), '<')
  }

  burgerTimeline() {
    const tl = gsap.timeline({ duration: 0.1 })
    tl.set('.b-2, b-3', { transformOrigin: 'center' })
    tl.to('.b-1,.b-4', { autoAlpha: 0 })
    tl.to('.b-2', { rotate: -45, transformOrigin: 'center' }, '<')
    tl.to('.b-3', { rotate: 45, transformOrigin: 'center' }, '<')
    return tl
  }

  toggleMenu() {
    if (this.state) {
      this.closeMenu()
    } else {
      this.openMenu()
    }
  }

  async closeMenu() {
    if (!this.state) return
    this.tl.timeScale(1.5).reverse()
    this.state = false
    this.enableBodyScroll()
  }

  async openMenu() {
    if (this.state) return
    this.tl.timeScale(1).play()
    this.state = true
    this.disableBodyScroll()
  }

  disableBodyScroll() {
    this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
    this.scrollWidth = window.innerWidth - document.documentElement.clientWidth

    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${this.scrollPosition}px`
    document.body.style.width = `calc(100% - ${this.scrollWidth}px)`
  }

  enableBodyScroll() {
    document.body.style.overflow = ''
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    window.scrollTo(0, this.scrollPosition)
  }
}
